module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-miyazaki-2-f0e9a53419c6ba5171063c1014009722.png";